export const CTA_URL = "https://form.jotform.com/251774480807060";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_divine-journey-53/artifacts/vmxz6r6q_NOUVEAU%20LOGO%20CMC%20%281%29.png";

export const IMAGES = {
  heroBg:
    "https://images.unsplash.com/photo-1759937456722-c8e73dfd5128?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxkYXJrJTIwY2F0aGVkcmFsJTIwaW50ZXJpb3IlMjBnb2xkZW4lMjBsaWdodHxlbnwwfHx8fDE3ODMyODMzOTR8MA&ixlib=rb-4.1.0&q=85",
  choir:
    "https://images.unsplash.com/photo-1548795835-264877304664?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxnb3NwZWwlMjBjaG9pciUyMHNpbmdpbmclMjBkcmFtYXRpYyUyMGxpZ2h0fGVufDB8fHx8MTc4MzI4MzM5NHww&ixlib=rb-4.1.0&q=85",
  choir2:
    "https://images.unsplash.com/photo-1577928988314-333ee58c5296?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxnb3NwZWwlMjBjaG9pciUyMHNpbmdpbmclMjBkcmFtYXRpYyUyMGxpZ2h0fGVufDB8fHx8MTc4MzI4MzM5NHww&ixlib=rb-4.1.0&q=85",
  piano:
    "https://images.unsplash.com/photo-1552422530-9b41dc72286b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwzfHxwaWFuaXN0JTIwcGxheWluZyUyMGdyYW5kJTIwcGlhbm8lMjBtb29keXxlbnwwfHx8fDE3ODMyODMzOTR8MA&ixlib=rb-4.1.0&q=85",
  singerWoman:
    "https://images.unsplash.com/photo-1522863602463-afebb8886ab2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxwb3J0cmFpdCUyMGJsYWNrJTIwc2luZ2VyJTIwd29yc2hpcCUyMG1pY3JvcGhvbmV8ZW58MHx8fHwxNzgzMjgzMzk0fDA&ixlib=rb-4.1.0&q=85",
  singerSmoke:
    "https://images.unsplash.com/photo-1595422656857-ced3a4a0ce25?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxwb3J0cmFpdCUyMGJsYWNrJTIwc2luZ2VyJTIwd29yc2hpcCUyMG1pY3JvcGhvbmV8ZW58MHx8fHwxNzgzMjgzMzk0fDA&ixlib=rb-4.1.0&q=85",
  singerStage:
    "https://images.unsplash.com/photo-1600119692901-94e8b7d2eacd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxwb3J0cmFpdCUyMGJsYWNrJTIwc2luZ2VyJTIwd29yc2hpcCUyMG1pY3JvcGhvbmV8ZW58MHx8fHwxNzgzMjgzMzk0fDA&ixlib=rb-4.1.0&q=85",
};

export const FOUNDER_IMG =
  "https://customer-assets.emergentagent.com/job_divine-journey-53/artifacts/dcg6g2a2_IMG_0069.webp";

export const STUDENTS_IMG =
  "https://customer-assets.emergentagent.com/job_divine-journey-53/artifacts/x1h3yaf8_IMG_D11785FC90BB-1.jpeg";

// Real team members (photos provided by the client), left-to-right order.
export const TEAM = [
  {
    name: "Anges Fradoïc",
    role: "Professeur de guitare",
    detail: "Classique & électrique",
    img: "https://customer-assets.emergentagent.com/job_divine-journey-53/artifacts/v8hyku56_IMG_2881.jpeg",
  },
  {
    name: "Marlyse",
    role: "Professeure de chant",
    detail: "Technique vocale & interprétation",
    img: "https://customer-assets.emergentagent.com/job_divine-journey-53/artifacts/ea34mqri_IMG_7626.jpeg",
  },
  {
    name: "Hermann",
    role: "Coach vocal",
    detail: "Souffle, justesse & présence",
    img: "https://customer-assets.emergentagent.com/job_divine-journey-53/artifacts/btdb9q9f_IMG_0196.jpeg",
  },
  {
    name: "Fordha",
    role: "Professeur de saxophone",
    detail: "Improvisation & jeu gospel",
    img: "https://customer-assets.emergentagent.com/job_divine-journey-53/artifacts/aovnqqzi_IMG_604FD5B65145-1.jpeg",
  },
  {
    name: "Mikael",
    role: "Professeur de piano, basse & batterie",
    detail: "Rythmique & accompagnement",
    img: "https://customer-assets.emergentagent.com/job_divine-journey-53/artifacts/r8i9cr9s_3786a2bd-b46e-4029-98e6-f40d9cd0cec4.jpeg",
  },
  {
    name: "Jonathan Vouteau",
    role: "Fondateur & CEO",
    detail: "Auteur de la méthode CMC-EdgarDale",
    img: FOUNDER_IMG,
  },
];

// VSL video (compressed MP4, served from /public). Native HTML5 video.
export const VSL_VIDEO_URL = `${process.env.PUBLIC_URL || ""}/cmc-presentation.mp4`;

// Reservation page (long VSL shown to eligible prospects before Calendly).
export const CALENDLY_URL =
  "https://calendly.com/conservatoire_gospel/consultation-gratuite";
// VSL longue hébergée sur YouTube (non répertorié).
export const RESERVATION_YT_ID = "UvJYvNJiynY";
export const RESERVATION_VSL_MINUTES = 20;

// Vidéos témoignages (compressées H.264, servies depuis /public).
export const TESTIMONIAL_VIDEOS = [
  { src: `${process.env.PUBLIC_URL || ""}/temoignage-1.mp4`, role: "Élève de chant" },
  { src: `${process.env.PUBLIC_URL || ""}/temoignage-2.mp4`, role: "Élève de chant / piano" },
  { src: `${process.env.PUBLIC_URL || ""}/temoignage-3.mp4`, role: "Élève de chant / piano" },
  { src: `${process.env.PUBLIC_URL || ""}/temoignage-4.mp4`, role: "Élève de piano" },
  { src: `${process.env.PUBLIC_URL || ""}/temoignage-5.mp4`, role: "Élève de piano" },
];
